import {useIntl} from "react-intl";
import React, {useRef, useState} from "react";
import './PlayerNameFilter.style.scss';

const PlayerNameFilter = ({vm, onExpandChange}) => {
    const intl = useIntl();
    const {locale} = useIntl();
    const [isExpanded, setIsExpanded] = useState(false);
    const inputRef = useRef(null);

    const expand = () => {
        setIsExpanded(true);
        onExpandChange?.(true);
        inputRef.current?.focus();
    };

    const collapse = () => {
        setIsExpanded(false);
        onExpandChange?.(false);
        vm.handleFilterChange("searchTerm", "");
    };

    const handleFocus = () => {
        setIsExpanded(true);
        onExpandChange?.(true);
        vm.handleFilterChange('position', null);
    };

    const handleBlur = () => {
        if (!vm.filters.searchTerm) {
            setIsExpanded(false);
            onExpandChange?.(false);
        }
    };

    return (
        <div
            className={`PlayerNameFilter ${isExpanded ? 'expanded' : ''}`}
            onClick={!isExpanded ? expand : undefined}
        >
            <i className="searchIcon fa-solid fa-magnifying-glass"/>
            <input
                ref={inputRef}
                id={"searchPlayerNameTxt"}
                type="text"
                placeholder={intl.formatMessage({id: "lobbyView.filter.searchByPlayer"})}
                className={`searchBar ${locale}`}
                value={vm.filters.searchTerm}
                onChange={(e) => vm.handleFilterChange("searchTerm", e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
            {isExpanded && (
                <button className="closeSearch" onMouseDown={(e) => { e.preventDefault(); collapse(); }}>
                    <i className="fa-solid fa-xmark"/>
                </button>
            )}
        </div>
    );
}

export default PlayerNameFilter;
